<script>
import BaseButtonElement from "%/dynamic-component-editor/standard-elements/button-element/BaseButtonElement.vue";
import Label from "%/dynamic-component-editor/options/label";
import { LabelButtonMixin } from "%/dynamic-component-editor/standard-components/plan-sheet/label-button-mixin";
import { suppressesNavigation } from "%/dynamic-component-editor/helpers/builder-navigation-guard";
import { SUBSCRIPTION_MANAGEMENT_PAGE_SLUG } from "%/dynamic-component-editor/constants/publication-constants";
import { useGeneralStore } from "%/dynamic-component-editor/stores/general-store";
import { links } from "%/dynamic-component-editor/enums/link-enums";
import { isViewerSubscribed } from "%/dynamic-component-editor/standard-elements/upsell-element/resolve-viewer-subscription";
import {
  readSessionSubscription,
  resolveManageSubscriptionLink,
} from "%/dynamic-component-editor/standard-components/plan-sheet/plan-sheet-state";

// Shown to a paying subscriber; opens wherever that subscription is managed.
export default {
  name: "ManageSubscriptionButton",
  extends: BaseButtonElement,
  mixins: [LabelButtonMixin],
  elementPanelSettings: {
    displayName: "Manage Subscription",
    displayIcon: "button",
    elementType: "element",
    tags: ["payments", "manage", "billing", "cancel"],
  },
  options: [
    new Label({ "default": "Manage subscription" }),
  ],
  computed: {
    shouldRenderButton() {
      return this.editMode || isViewerSubscribed();
    },
  },
  methods: {
    handleButtonClick() {
      if (suppressesNavigation(this)) {
        return;
      }
      const link = resolveManageSubscriptionLink(
        readSessionSubscription(),
        useGeneralStore().getLink(links.web),
        SUBSCRIPTION_MANAGEMENT_PAGE_SLUG,
      );
      if (link.external) {
        window.open(link.href, "_blank", "noopener");
        return;
      }
      window.location.href = link.href;
    },
  },
};
</script>
